/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ school: NonNullable<unknown> }} Planning_Rooster_GymroosterInputs */

const nl_planning_rooster_gymrooster = /** @type {(inputs: Planning_Rooster_GymroosterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gymrooster van ${i?.school}`)
};

/**

* @param {Planning_Rooster_GymroosterInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_rooster_gymrooster = /** @type {((inputs: Planning_Rooster_GymroosterInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Rooster_GymroosterInputs, { locale?: "nl" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_rooster_gymrooster(inputs)
});
export { planning_rooster_gymrooster as "planning.rooster.gymrooster" }